import { toast } from "sonner";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Garage contactgegevens - pas hier aan met de echte gegevens
export const GARAGE = {
  name: "Milano Worx Autogarage",
  brand: "MILANO WORX",
  logoUrl: "/logo.png",
  phoneDisplay: "+32 465 63 94 28",
  phoneHref: "tel:+32465639428",
  whatsapp: "32465639428",
  email: "milanoworx.garage@gmail.com",
  address: "Ijskelderstraat 12, 2660 Hoboken",
  mapsQuery: "Ijskelderstraat 12, 2660 Hoboken",
  iban: "BE64 0689 4449 1552",
  beneficiary: "Milano Worx Autogarage",
  btw: "BE 0653 990 833",
  hours: [
    ["Maandag - Vrijdag", "09:15 - 19:15"],
    ["Zaterdag", "Op afspraak"],
    ["Zondag", "Gesloten"],
  ],
  instagram: "https://instagram.com/milano_worx",
  tiktok: "#",
  facebook: "#",
};

export const waLink = (msg) =>
  `https://wa.me/${GARAGE.whatsapp}?text=${encodeURIComponent(msg)}`;

export async function submitRequest(type, data, files = []) {
  const fd = new FormData();
  fd.append("type", type);
  fd.append("payload", JSON.stringify(data));
  files.forEach((f) => fd.append("files", f));
  const res = await fetch(`${API}/requests`, { method: "POST", body: fd });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(typeof err.detail === "string" ? err.detail : "Er ging iets mis. Probeer opnieuw.");
  }
  const json = await res.json();
  if (json.rejected_files?.length) {
    toast.warning(`${json.rejected_files.length} bestand(en) overgeslagen: te groot of niet ondersteund (max 8MB, jpg/png/webp/heic/mp4/mov).`);
  }
  return json;
}

export const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem("mw_token") || ""}`,
});
